<script>
import { app } from '@/main'

import {
  LogAdShownDetailPixel,
  LogAdShownCarDetail,
  LogPrintAd,
  LogCriteoProduct,
  LogCriteoConfirmation,
  LogFacebookView,
} from '@/events'

export default {
  template: '<template></template>',
  methods: {
    handlePrint(adId) {
      LogPrintAd(adId)
      LogCriteoConfirmation(+adId)
    },
  },
  mounted() {
    const adEventHookData = document.querySelector('#adEventHookData')

    if (adEventHookData !== null) {
      /***************/
      /* Handle View */
      /***************/

      const productTypeId = adEventHookData.getAttribute('data-product-type-id')
      if (productTypeId === '1') {
        LogAdShownCarDetail()
      }

      const adId = adEventHookData.getAttribute('data-ad-id'),
        adTitle = adEventHookData.getAttribute('data-ad-title'),
        adPrice = adEventHookData.getAttribute('data-ad-price'),
        adFacebookRetargetingValues = adEventHookData.getAttribute(
          'data-facebook-retargeting-values'
        ),
        adIsPrivate = adEventHookData.getAttribute('data-ad-is-private')

      if (adId !== null) {
        const type = adIsPrivate == 'True' ? 'private' : 'company'
        LogAdShownDetailPixel(adId, type)

        /*****************/
        /* Handle Criteo */
        /*****************/
        LogCriteoProduct(+adId)

        /*******************/
        /* Handle Facebook */
        /*******************/
        LogFacebookView(adId, adTitle, adPrice, adFacebookRetargetingValues)

        /****************/
        /* Handle Print */
        /****************/
        app.mitt.on('print', () => {
          this.handlePrint(adId)
        })
      }
    }
  },
}
</script>
